import styled from "styled-components";

import MainNavButton from "../MainNav/Button";

export const BuyDropdownButton = styled(MainNavButton)``;
